export default __webpack_public_path__ + "static/media/mesopotamia-ship.99cd0605.png";